import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";

export default function BehindTheIdea() {
  const navigate = useNavigate();
  const [collaborators, setCollaborators] = useState([]);
  const [deleteId, setDeleteId] = useState(null);

  

  /* 🔌 GET ALL COLLABORATORS */
  useEffect(() => {
    axios
      .get("https://api.livestockify.com/api/admin/behind-idea")
      .then((res) => setCollaborators(res.data));

  }, []);



  const handleDelete = async () => {
  try {
    await axios.delete(
      `https://api.livestockify.com/api/admin/behind-idea/${deleteId}`
    );

    setCollaborators((prev) =>
      prev.filter((c) => c.id !== deleteId)
    );
    setDeleteId(null);
  } catch (err) {
    console.error("Delete failed", err);
  }
};

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      <div className="flex-1 bg-white rounded-l-2xl p-4 md:p-8 pl-14 md:pl-8">
        {/* HEADER */}
     
        <div className="mb-6 flex flex-col items-center md:flex-row md:justify-between md:items-center gap-3">
  <h1 className="text-lg font-semibold text-green-700 text-center md:text-left">
    Solutions - Collaborators
  </h1>

  <button
    onClick={() => navigate("/uploads/behind-idea/add")}
    className="border px-4 py-2 rounded-md text-sm md:text-base w-full max-w-xs md:w-auto"
  >
    + Add Idea
  </button>
</div>


        {/* CARDS */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-2">
          {collaborators.map((c) => (
            <CollaboratorCard
              key={c.id}
              collaborator={c}
              onEdit={() =>
                navigate(`/uploads/behind-idea/edit/${c.id}`)
              }
              // onDelete={() => handleDelete(c.id)}
              onDelete={() => setDeleteId(c.id)}

            />
          ))}
        </div>
      </div>


          {deleteId && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl p-6 w-[90%] max-w-sm">
      <h3 className="text-lg font-semibold mb-3">
        Confirm Deletion
      </h3>

      <p className="text-sm text-gray-600 mb-6">
        Are you sure you want to proceed with this deletion?
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={() => setDeleteId(null)}
          className="border px-4 py-2 rounded-md text-sm"
        >
          Cancel
        </button>

        <button
          onClick={handleDelete}
          className="bg-red-600 text-white px-4 py-2 rounded-md text-sm"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

/* 🔹 COLLABORATOR CARD */
function CollaboratorCard({ collaborator, onEdit, onDelete }) {
  return (
    <div className="border rounded-xl shadow-sm overflow-hidden max-w-[240px]">
      <img
        src={collaborator.imageUrl}
        alt={collaborator.name}
        className="w-full h-48 object-cover"
      />

      <div className="p-3">
        <p className="text-sm font-semibold text-green-700">
          {collaborator.name} – {collaborator.role}
        </p>

        <p className="text-xs text-gray-600 mt-1">
          {collaborator.description}
        </p>

        <div className="flex justify-end gap-3 mt-3 text-xs">
          <button onClick={onEdit} className="text-green-600">
            Edit
          </button>
          <button onClick={onDelete} className="text-red-500">
            Delete
          </button>
        </div>
      </div>

  

    </div>
  );
}
